import { OurContext } from '../context';

export enum ERRORS {
  NETWORK_ISSUE = 'NETWORK_ISSUE',
  UNKNOWN = 'UNKNOWN',
  INVALID_INPUT = 'INVALID_INPUT',
  REFUSED = 'REFUSED',
  UNEXPECTED_AUTHORISATION = 'UNEXPECTED_AUTHORISATION',
  KLARNA_NOT_SUPPORTED = 'KLARNA_NOT_SUPPORTED',
}

export function mapErrorMessage(context: OurContext, err: Error | string): string {
  if (err instanceof BackendError) {
    return err.message;
  }
  const message = typeof err === 'string' ? err : err.message;
  switch (message) {
    case ERRORS.NETWORK_ISSUE:
      return context.texts.networkIssue.replace('{brand}', context.currentTheme);
    case ERRORS.INVALID_INPUT:
      return context.texts.invalidInput;
    case ERRORS.KLARNA_NOT_SUPPORTED:
      return context.texts.klarnaNotSupported;
    case ERRORS.REFUSED:
      return context.texts.cardRefused;
    case ERRORS.UNEXPECTED_AUTHORISATION:
      return context.texts.unexpectedAuthorisation;
    case ERRORS.UNKNOWN:
    default:
      return context.texts.unknownIssue;
  }
}

export class BackendError extends Error {}
